<template>
    <guest-card>
        <login-form :is-under="isUnder" :isCompany="isCompany === true ? isCompany : isStudent === true ? !isStudent : true"/>
    </guest-card>
</template>

<script>
    import guestCard from "@/components/cards/guestCard";
    import loginForm from "@/components/forms/loginForm"
    export default {
        title: "Job Fair Faculty of Engineering - Login",
        name: "login",
        components: {
          guestCard,
          loginForm
        },
        props: {
            isStudent: Boolean,
            isCompany: Boolean,
            isUnder: {
              type: Boolean,
              default: false
            }
        }

    }
</script>

<style scoped>
</style>